"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreconnectLinks = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const PreconnectLinks = ({
  servicesUrls,
  thirdPartyConfiguration
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [!!servicesUrls?.clientApps.baseUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
    rel: "preconnect",
    href: servicesUrls.clientApps.baseUrl
  }), !!servicesUrls?.graphQlNet.baseUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
    rel: "preconnect",
    href: servicesUrls.graphQlNet.baseUrl
  }), !!servicesUrls?.staticStorage.baseUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
    rel: "preconnect",
    href: servicesUrls.staticStorage.baseUrl
  }), !!thirdPartyConfiguration?.didomi && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      rel: "preconnect",
      href: thirdPartyConfiguration.didomi.scriptDomain
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
      rel: "dns-prefetch",
      href: thirdPartyConfiguration.didomi.scriptDomain
    })]
  }), !!thirdPartyConfiguration?.gtm && /*#__PURE__*/(0, _jsxRuntime.jsx)("link", {
    rel: "preconnect",
    href: `https://www.googletagmanager.com/gtm.js?id=${thirdPartyConfiguration.gtm.gtmId}`
  })]
});
exports.PreconnectLinks = PreconnectLinks;
